import React, { useState } from 'react';
import { C } from '../data/constants';
import { NudgeLogo, PrimaryBtn, SecondaryBtn } from './shared/UI';

export default function Auth({ onSuccess, onBack }) {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const generateStudyId = () => {
    const num = Math.floor(1000 + Math.random() * 9000);
    return `NUD-${num}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError('Please fill in all fields.'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }

    setLoading(true);
    // Simulate auth (mock — frontend only)
    await new Promise(r => setTimeout(r, 600));

    if (mode === 'register') {
      const studyId = generateStudyId();
      onSuccess({ email, studyId, registeredAt: new Date().toISOString() });
    } else {
      // Mock login — load from localStorage if exists
      const saved = localStorage.getItem('nudge-user-v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.email === email) {
          onSuccess(parsed);
        } else {
          setError('No account found with that email.');
          setLoading(false);
          return;
        }
      } else {
        setError('No account found. Please register first.');
        setLoading(false);
        return;
      }
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', background: C.bg,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ marginBottom: 28 }}>
        <NudgeLogo size="lg" />
      </div>

      <div style={{
        background: C.card, border: `1px solid ${C.border}`,
        borderRadius: 12, padding: 36,
        width: '100%', maxWidth: 420,
      }}>
        <h2 style={{
          fontFamily: "'DM Serif Display', serif",
          fontSize: 26, color: C.navy, fontWeight: 400,
          marginBottom: 6, textAlign: 'center',
        }}>
          {mode === 'login' ? 'Welcome back' : 'Create your account'}
        </h2>
        <p style={{ fontSize: 14, color: C.muted, textAlign: 'center', marginBottom: 28 }}>
          {mode === 'login' ? 'Sign in to continue your study' : 'Join the NudgeAI research study'}
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: C.text, marginBottom: 6 }}>Email address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={{
                width: '100%', padding: '10px 14px',
                border: `1px solid ${C.border}`, borderRadius: 8,
                fontSize: 14, color: C.text, outline: 'none',
                fontFamily: "'DM Sans', sans-serif",
              }}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: C.text, marginBottom: 6 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Min. 6 characters"
              style={{
                width: '100%', padding: '10px 14px',
                border: `1px solid ${C.border}`, borderRadius: 8,
                fontSize: 14, color: C.text, outline: 'none',
                fontFamily: "'DM Sans', sans-serif",
              }}
            />
          </div>

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca',
              borderRadius: 8, padding: '10px 14px', marginBottom: 16,
            }}>
              <p style={{ color: '#dc2626', fontSize: 13, margin: 0 }}>{error}</p>
            </div>
          )}

          <PrimaryBtn
            disabled={loading}
            fullWidth
            style={{ padding: '12px', fontSize: 15 }}
            onClick={undefined}
          >
            {loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : 'Create Account'}
          </PrimaryBtn>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          {mode === 'login' ? (
            <p style={{ fontSize: 13, color: C.muted }}>
              New to NudgeAI?{' '}
              <button onClick={() => { setMode('register'); setError(''); }}
                style={{ color: C.teal, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, fontFamily: "'DM Sans', sans-serif" }}>
                Create an account
              </button>
            </p>
          ) : (
            <p style={{ fontSize: 13, color: C.muted }}>
              Already registered?{' '}
              <button onClick={() => { setMode('login'); setError(''); }}
                style={{ color: C.teal, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, fontFamily: "'DM Sans', sans-serif" }}>
                Sign in
              </button>
            </p>
          )}
        </div>
      </div>

      <button
        onClick={onBack}
        style={{
          marginTop: 20, color: C.muted, background: 'none', border: 'none',
          cursor: 'pointer', fontSize: 13, fontFamily: "'DM Sans', sans-serif",
        }}
      >
        &larr; Back to home
      </button>
    </div>
  );
}
